<template>
	<div class="panel panel-custom">
		<div class="panel-heading">
			<i class="fa fa-calendar pull-right" style="margin-top:5px;"></i>
			<strong class="text-uppercase">{{ agenda.formatedDate }}</strong>
		</div>
		<table class="table table-bordered" v-if="agenda.horas && agenda.horas.length > 0">
			<thead>
				<tr>
					<th width="10" class="text-center">HORA</th>
					<th class="text-center">SITUAÇÃO</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="slot in agenda.horas">
					<td>
						<!-- permite agendamentos -->
						<template v-if="slot.status.id === 1">
							<router-link :to="`/agendas/${$route.params.data}-${slot.hora}/cadastro?slot=${slot.id}`">
								{{ slot.hora }}
							</router-link>
						</template>

						<!-- não permite agendamentos -->
						<template v-else>
							{{ slot.hora }}
						</template>
					</td>
					<td class="text-uppercase">
						<!-- permite agendamentos -->
						<template v-if="slot.status.id === 1">
							<router-link :to="`/agendas/${$route.params.data}-${slot.hora}/cadastro?slot=${slot.id}`">
								<span class="label label-primary" v-if="slot.status.id === 1">{{ slot.status.nome }}. CLIQUE PARA AGENDAR</span>
							</router-link>
						</template>

						<!-- não permite agendamentos -->
						<template v-else>
							<span class="label label-danger" v-if="slot.status.id === 2 || slot.status.id === 4">{{ slot.status.nome }}</span>
							<span class="label label-warning" v-if="slot.status.id === 3">{{ slot.status.nome }}</span>
							<span class="label label-info" v-if="slot.agendamento">{{ slot.agendamento.nome.split(' ')[0] }}</span>
							<span class="label label-success" v-if="slot.agendamento && slot.agendamento.confirmado">CONFIRMADO</span>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="panel-body" v-else>
			<div class="alert alert-warning text-center text-uppercase" style="margin-bottom:0;">
				<strong>{{ agenda.observacao }}</strong>
			</div>
		</div>
	</div>
</template>

<script>
	import Moment from 'moment';
	import 'moment/locale/pt-br';
	import Agenda from 'models/agenda';

	export default {
		data() {
			return {
				agenda: ''
			};
		},

		async created() {
			this.agenda = await this.getAgenda(this.$route.params.data);
		},

		methods: {
			async getAgenda(data) {
				let agendas = await Agenda.getAll();
				let agenda = agendas.filter(a => Moment(a.data, 'DD/MM/YYYY').format('DD-MM-YYYY') === data)[0];

				agenda.formatedDate = Moment(agenda.data, 'DD/MM/YYYY').format('DD [de] MMMM [de] YYYY');

				agenda.horas = agenda.horas.sort((a, b) => {
					let aa = Number(a.hora.replace(':', ''));
					let bb = Number(b.hora.replace(':', ''));

					return aa > bb ? 1 : aa < bb ? -1 : 0;
				});

				return agenda;
			}
		}
	};
</script>

<style scoped>
	table thead tr th,
	table tbody tr td {
		font-size: 16px;
		text-align: center;
	}

	table tbody tr:hover {
		background: lightgoldenrodyellow;
	}

	table tbody tr td {
		height: 60px;
		vertical-align: middle;
		padding: 0;
	}

	table tbody tr td a {
		display: block;
		line-height: 60px;
		color: inherit;
	}

	table tbody tr td a:active,
	table tbody tr td a:focus,
	table tbody tr td a:hover {
		text-decoration: none;
	}

	.label {
		font-size: 12px;
		line-height: inherit;
	}

	/*smartphones*/
	@media (max-width: 767px) {
		table th {
			font-size: 14px;
		}

		.label {
			font-size: 11px;
		}
	}
</style>


// WEBPACK FOOTER //
// agenda.vue?1145c414